// Cycle-16 new-messages divider. Mirrors `PingNewMessagesDivider`
// (iOS-A) / `NewMessagesDivider` (AND-A). Renders a full-width
// horizontal rule with a right-aligned 'NEW' pill, both coloured
// `accent.rose`, from the Figma `New Messages divider`
// (`3412:5373`/`5374`) frame. Pure presentational.

import React from 'react';
import { Text, View } from 'react-native';

export interface NewMessagesDividerProps {
  label?: string | undefined;
  // Accepted for caller compatibility; not rendered on web/desktop.
  unreadCount?: number | undefined;
  testID?: string | undefined;
}

// Figma 7038:2314 "New Messages divider" — a full-width 1px rule plus a
// right-aligned "NEW" pill, both the signal red #D5363C (no design token —
// snapped per docs/architecture/figma-token-mismatches.md). Label is
// #F5F6F8, Lato 700 10/14; pill radius 8. Tailwind-first; class-based theme.
export const NewMessagesDivider = React.memo<NewMessagesDividerProps>(
  ({ label = 'NEW', testID }) => {
    return (
      <View
        className="flex-row items-center px-3 py-2"
        accessibilityRole="text"
        accessibilityLabel={label}
        testID={testID}
      >
        <View className="flex-1 h-px bg-[#D5363C]" />
        <View className="rounded-[8px] px-1 py-0.5 bg-[#D5363C]">
          <Text className="font-sans text-[10px] font-bold leading-[14px] text-[#F5F6F8]">
            {label.toUpperCase()}
          </Text>
        </View>
      </View>
    );
  },
);

NewMessagesDivider.displayName = 'NewMessagesDivider';
